import { Theme } from '@material-ui/core'
import { TypographyOptions } from '@material-ui/core/styles/createTypography'
import FontSize from './definitions/fontSize'

export default function TypographyOverrides(theme: Theme): TypographyOptions {
  return {
    body1: {
      fontFamily: theme.typography.fontFamily,
      fontSize: FontSize['base'],
      lineHeight: 1.375,
    },
    body2: {
      fontFamily: theme.typography.fontFamily,
      fontSize: FontSize['base'],
      lineHeight: 1.625,
    },
    h1: {
      fontFamily: theme.typography.fontFamily2,
      fontSize: FontSize['4xl'],
      lineHeight: 1.2,
      fontWeight: 500,
      marginBottom: theme.spacing(8),
      [theme.breakpoints.up('lg')]: {
        fontSize: FontSize['6xl'],
      },
    },
    h2: {
      fontFamily: theme.typography.fontFamily2,
      fontSize: FontSize['3xl'],
      lineHeight: 1.2,
      fontWeight: 500,
      marginBottom: theme.spacing(6),
      [theme.breakpoints.up('lg')]: {
        fontSize: FontSize['5xl'],
      },
    },
    h3: {
      fontFamily: theme.typography.fontFamily2,
      fontSize: FontSize['xl'],
      lineHeight: 1.3,
      fontWeight: 500,
      marginBottom: theme.spacing(4),
      [theme.breakpoints.up('lg')]: {
        fontSize: FontSize['3xl'],
      },
    },
    h4: {
      fontFamily: theme.typography.fontFamily2,
      fontSize: FontSize['2lg'],
      lineHeight: 1.2,
      fontWeight: 500,
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up('lg')]: {
        fontSize: FontSize['xl'],
      },
    },
    h5: {
      fontFamily: theme.typography.fontFamily2,
      fontSize: FontSize['lg'],
      lineHeight: 1.2,
      fontWeight: 500,
      marginBottom: theme.spacing(2),
    },
    infotext: {
      fontFamily: theme.typography.fontFamily,
      fontSize: FontSize['base'],
      lineHeight: 1,
      fontWeight: 500,
      color: theme.palette.text.tertiary,
    },
    caption: {
      fontSize: FontSize['sm'],
      lineHeight: 1.14,
      color: theme.palette.text.secondary,
      fontStyle: 'normal',
    },
    link: {
      fontWeight: 700,
      color: theme.palette.text.highlight,
      '&:focus': {
        color: theme.palette.text.primary,
        textDecoration: 'underline',
      },
      '&:hover': {
        color: theme.palette.error.light,
        textDecoration: 'none',
      },
    },
    navigation: {
      fontFamily: theme.typography.fontFamily2,
      fontSize: FontSize['lg'],
      fontWeight: 500,
      lineHeight: 1.3334,
    },
    navigationSecondary: {
      [theme.breakpoints.up('xl')]: {
        fontFamily: theme.typography.fontFamily2,
        fontWeight: 500,
        fontSize: FontSize['2lg'],
        lineHeight: 1.3334,
      },
    },
    navigationMeta: {
      fontFamily: theme.typography.fontFamily2,
      fontWeight: 500,
    },
    breadcrumb: {
      lineHeight: 1.625,
    },
    buttonPrimary: {
      fontFamily: theme.typography.fontFamily2,
      fontSize: FontSize['2lg'],
      fontWeight: 500,
    },
    buttonSecondary: {
      fontFamily: theme.typography.fontFamily2,
      fontWeight: 500,
      fontSize: FontSize['lg'],
    },
    buttonText: {
      fontFamily: theme.typography.fontFamily2,
      fontWeight: 500,
      fontSize: 'inherit',
    },
    footernavigation: {
      fontSize: FontSize['lg'],
      lineHeight: 1.3334,
      [theme.breakpoints.down('md')]: {
        fontSize: FontSize['base'],
      },
    },
    helpertext: {
      fontSize: FontSize['sm'],
      lineHeight: 1.125,
    },
    smallHelperText: {
      fontSize: FontSize['xs'],
      lineHeight: 1.125,
    },
    input: {
      lineHeight: 1.25,
    },
    label: {
      fontSize: FontSize['lg'],
      lineHeight: 1.278,
      fontWeight: 500,
    },
    checkboxOption: {
      fontSize: FontSize['lg'],
    },
    toc: {
      lineHeight: 1.5,
      fontSize: FontSize['base'],
    },
    teaser: {
      fontSize: FontSize['sm'],
      color: theme.palette.text.teaser,
    },
  }
}
